import Vue from "vue";
import Router from "vue-router";
import Base from "./views/base.vue";
import LiveCenter from "./views/liveCenter";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: Base,
      props: {
        routeGroupKey: "index",
      },
      children: [
        {
          path: "",
          component: LiveCenter,
        },
        {
          path: "/demo-for-native",
          component: () => import("./views/demoForNative"),
        },
        {
          path: "/live/:id",
          component: () => import("./views/liveStream"),
        },
        {
          path: "/tornament/:id",
          component: () => import("./views/videoPlayer"),
          props: {
            videoType: "tornament",
          },
        },
        {
          path: "/liveBroadcast/:id",
          component: () => import("./views/videoPlayer"),
          props: {
            videoType: "liveBroadcast",
          },
        },
        {
          path: "/video-list",
          component: () => import("./views/videoList/index"),
          name: "videoList",
        },
        {
          path: "/video/:id",
          component: () => import("./views/videoPlayer"),
          props: {
            videoType: "video",
          },
        },
        {
          path: "/news",
          component: () => import("./views/news/index"),
        },
        {
          path: "/personal-center",
          component: () => import("./views/personalCenter/index"),
        },
        {
          path: "/gamble",
          component: () => import("./views/gamble/index"),
          meta: { bgType: 2 },
        },
        {
          path: "/e-sport/:tab?/:itemId?",
          component: () => import("./views/eSport/index"),
        },
      ],
    },
    {
      path: "/feedback",
      component: Base,
      props: {
        routeGroupKey: "index",
      },
      children: [
        {
          path: "",
          name: "",
          props: {
            isRouteOpen: true,
          },
          component: () => import("./views/feedback/index"),
        },
      ],
    },
  ],
});
